import { useEffect, useState } from "react";

export const OldUrlRedirectProvider = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const [checked, setChecked] = useState(false);
  // redirect old domain to new domain
  useEffect(() => {
    if (window.location.hostname === "localhost") {
      setChecked(true);
      return;
    }
    if (window.location.hostname !== process.env.REACT_APP_WEB_DOMAIN) {
      const pathname = window.location.pathname.startsWith("/novel-studio")
        ? window.location.pathname
        : `/novel-studio${window.location.pathname}`;
      console.log(
        "newLocation",
        `//${process.env.REACT_APP_WEB_DOMAIN}${pathname}${window.location.search}`,
      );
      window.location.href = `//${process.env.REACT_APP_WEB_DOMAIN}${pathname}${window.location.search}`;
    }
    setChecked(true);
  }, []);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
};
